import { render } from "./banner-six.vue?vue&type=template&id=3da7a582"
import script from "./banner-six.vue?vue&type=script&lang=js"
export * from "./banner-six.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__